// extracted by mini-css-extract-plugin
module.exports = {"anketaAlert":"AnketaAlert_anketaAlert__j5Pz5"};